import { useEffect, useMemo, useRef, useState } from "react";

// Keep the scan constraint independent from the currently selected position.
export function useStockSource(positions, compartments, prefill, setPositionId) {
    const [scope, setScope] = useState({});
    const selectFromScan = useRef(false);
    useEffect(() => {
        if (prefill) {
            selectFromScan.current = true;
            setScope({ compartmentId: prefill.compartmentId, articleId: prefill.articleId, staging: prefill.stagingSource });
        }
    }, [prefill]);
    const sourcePositions = useMemo(() => positions.filter(position =>
        position.quantity > 0 &&
        (!scope.compartmentId || position.compartment_id === scope.compartmentId) &&
        (!scope.articleId || position.article_id === scope.articleId) &&
        (!scope.staging || compartments[position.compartment_id]?.is_staging)
    ), [positions, scope, compartments]);
    useEffect(() => {
        const autoSelect = selectFromScan.current;
        if (positions.length > 0) selectFromScan.current = false;
        setPositionId(current => sourcePositions.some(position => position.id === current)
            ? current : autoSelect && sourcePositions.length === 1 ? sourcePositions[0].id : "");
    }, [sourcePositions, setPositionId, positions.length]);
    const scanSource = resolved => {
        selectFromScan.current = true;
        setPositionId("");
        if (resolved.kind === "compartment") setScope({ compartmentId: resolved.id });
        else setScope(current => ({ ...current, articleId: resolved.id }));
    };
    const resetSource = () => {
        selectFromScan.current = false;
        setPositionId("");
        setScope({});
    };
    const sourceLabel = scope.compartmentId
        ? `Quellfach: ${compartments[scope.compartmentId]?.name || scope.compartmentId} (${compartments[scope.compartmentId]?.code || "Fach"})`
        : scope.staging ? "Quelle: Staging-Fächer" : scope.articleId ? "Quelle: gescannter Artikel" : "";
    return { sourcePositions, scanSource, resetSource, sourceLabel };
}
